export default function (props: any) {
    return (
        <svg
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            {...props}
        >
            <g id="V1.2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="RIVER-2-Series-Intro-Video" transform="translate(-548.000000, -2327.000000)">
                    <g id="编组-44备份" transform="translate(384.000000, 1767.000000)">
                        <g id="编组-43" transform="translate(164.000000, 0.000000)">
                            <g id="编组-21" transform="translate(0.000000, 403.000000)">
                                <g id="编组-3备份" transform="translate(0.000000, 157.000000)">
                                    <rect id="矩形" fill="var(--bg-color)" x="0" y="0" width="24" height="24" rx="3"></rect>
                                    <g id="编组" transform="translate(3.000000, 9.000000)" fill="var(--font-color)">
                                        <polygon
                                            id="Fill-1"
                                            points="10.1438557 2.88999266 10.1438557 4.10993285 10.1438557 6.99996275 11.4230992 6.99996275 11.4230992 5.6287312 11.4230992 4.10993285 18.9992735 4.10993285 18.9992735 2.88999266"
                                        ></polygon>
                                        <polygon id="Fill-2" points="0 4.11004459 8.86135471 4.11004459 8.86135471 2.8900299 0 2.8900299"></polygon>
                                        <polygon id="Fill-3" points="0 1.22001469 8.86135471 1.22001469 8.86135471 0 0 0"></polygon>
                                        <polygon id="Fill-4" points="0 7 8.86135471 7 8.86135471 5.78005981 0 5.78005981"></polygon>
                                        <polygon id="Fill-5" points="10.1438791 1.21979121 19 1.21979121 19 0 10.1438791 0"></polygon>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
